import React from 'react'

import Routes from './routes'

const Index = () => {
  return <Routes />
}

export default Index
